<template>
  <details-sheet
    class="pa-3"
    :item="details"
    :headers="headers"
    v-bind="$attrs"
  >
    <template v-slot:item.business_customer="{ item }">
      <span>{{ (item.business_customer || {}).name }}</span>
      <v-btn v-if="showEyeLink" class="float-right" small icon :to="to">
        <v-icon>mdi-eye</v-icon>
      </v-btn>
    </template>

    <template v-slot:item.management_company="{ item }">
      <span>{{ (item.management_company || {}).name }}</span>
      <v-btn v-if="showEyeLink" class="float-right" small icon :to="to">
        <v-icon>mdi-eye</v-icon>
      </v-btn>
    </template>
  </details-sheet>
</template>

<script>
import DetailsSheet from '@/modules/_global/_components/DetailsSheet.vue';

export default {
  name: 'BuildingDetails',
  components: {
    DetailsSheet
  },

  props: {
    details: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    headers() {
      return [
        {
          text: this.$t('BUILDING_COMPLEXES.BUSINESS_CUSTOMER'),
          value: 'business_customer'
        },
        {
          text: this.$t('BUILDING_COMPLEXES.MANAGEMENT_COMPANY'),
          value: 'management_company'
        },
        {
          text: this.$t('BUILDING_COMPLEXES.ITEM'),
          value: 'building_complex_name'
        },
        {
          text: this.$t('SERVICES.ITEM'),
          value: 'service.name'
        }
      ];
    },

    showEyeLink() {
      return '';
    },

    to() {
      return {};
    }
  }
};
</script>
